import React from "react";

const PoliciesExperts = () => {
	return (
		<div>
			<h2>Acuerdos y Terminos de condiciones de uso</h2>
			<p>
				Needex es una aplicación que es enfocado en ser un instrumento digital
				que provee las referencias de profesionales en áreas técnicas, para la
				asistencia de reparaciones, servicios o cualquier otra necesidad para
				los usuarios y usuarias que lleguen a usar Needex. <br />La función
				principal de Needex es disponer referencias en el sector laboral
				técnico, en principio, para personas que necesiten la asistencia de los
				siguientes servicios como: refrigeración, electricidad, plomería,
				mecánica, construcción, carpintería, soldadura, pintura, lavadoras,
				jardinería y fumigación. <br />Estos mismos técnicos a los que nos
				referimos como profesionales ya sean licenciados o tengan otro tipo de
				formación. Las personas que lleguen a usar Needex siempre tendrán la
				libertad de usar o no usar nuestra aplicación, bajo las directrices que
				les demostramos al público de manera general. Formamos parte del sector
				informal pero privado, por lo que generamos recursos económicos a través
				de pagos por adelantado que se tienen por definidas como comisiones por
				los trabajos que baya a realizar el profesional y vaya a pagar el
				usuario o usuaria final. Descarga la aplicación Needex de forma sencilla
				y úsala. Si tú eres una persona con ganas de trabajar tienes la opción
				de descargar y usar Needex para poder ganar dinero con nosotros. Podrás
				escoger los trabajos más cercanos y los que mejor te convengan a ti.
				Podrás cobrar la tarifa que mejor consideres a lo que vale tu trabajo.
				Needex es una aplicación que sirve como instrumento digital que proveerá
				al público en general tus servicios como profesional a cambio de una
				comisión, dentro de la aplicación que será expresaba en créditos, que
				podrás comprar dentro de esta misma. Esto para facilitar el proceso
				haciéndolo mucho más interactivo y fácil de usar. <br />
				<br />-Needex es una aplicación que cobra una comisión por trabajo
				realizado, es decir que deberás comprar créditos para poder usar Needex.
				No te preocupes la comisión que cobramos es expresada en porcentaje del
				trabajo que vayas a cobrar por la actividad que vayas a desarrollar, que
				consta del 15% expresada en créditos de la aplicación. <br />-Tu
				información es necesaria para poder trabajar con nosotros, siempre por
				seguridad y posteriores calificaciones dentro de la aplicación, siendo
				que el proceso de registro es de manera sencilla y rápida, pero
				cualquier problema que tuvieses, puedes comunicarte con nosotros para
				poder guiarte. <br />-Debes entender que nosotros pedimos los siguientes
				requerimientos, por la seguridad de todas las partes, y que también lo
				hacemos para validar tu estado dentro de la aplicación. <br />-Dentro de
				la aplicación Needex habrán 2 estados para los expertos, estos que
				cumplan con los requisitos y los que no, serán definidos como
				“verificado” y “no verificado”. Los expertos que tengan el estado
				verificado serán aquellos que cumplan con los requisitos y podrán usar
				la aplicación para poder usarla como instrumento de búsqueda, para
				encontrar el requerimiento de trabajo. Con el estado verificado, que
				tendrá el experto podrá elegir ir al domicilio del usuario final o poder
				contactarse con el usuario final y pedirle que vaya al taller, oficina o
				denominado como domicilio laboral del experto, para mayor facilidad que
				brinda Needex. En cambio, el estado no verificado podrá simplemente
				navegar dentro de esta pero no se podrá acceder a las herramientas que
				brinda Needex. Es decir que no podrás acceder a ninguna propuesta de
				trabajo hasta que te verifiques. <br />-Los requisitos son; Hoja de
				vida, o curriculum vitae, junto con la fotocopia de los cursos que
				acreditan el nivel profesional o técnico del experto y por último los
				antecedentes penales. La entrega de los documentos podrá ser en el
				momento que tú quieras, luego de crearte tu cuenta en Needex en la
				pestaña que dirá “experto”. Nosotros pedimos esto solo en favor de la
				seguridad de ambas partes. Nosotros no contratamos ni brindamos
				beneficios sociales de ningún tipo. Los documentos se deberán entregar
				en El departamento de Santa Cruz, dirección Doble vía a La Guardia, 5to
				anillo, Avenida Flamingo Calle 2 Numero 9. Para cualquier duda acerca de
				la recepción de documentos podrás comunicarte a los números; 76336038 o
				77343092 o a las redes sociales que estarán a plena vista dentro de la
				aplicación. <br />-Debemos mencionar que como experto, se debe cumplir
				con el trabajo requerido y ofrecido, caso contrario en la aplicación se
				aplicara una penalización por el “no cumplimiento del trabajo”. Sea por
				falta de tiempo o cualquier contratiempo no justificado al cliente, se
				impondrá una suspensión de uso dentro de la aplicación que constara por
				instancias, siendo de la siguiente manera: Primera inhabilitación de uso
				de la aplicación por la falta al cumplimento del trabajo será por 3
				días, segunda falta, 10 días, y por una tercera falta será de manera
				permanente.
			</p>

			<h3>INFORMACION RECOGIDA</h3>
			<p>
				Needex es una aplicación que genera recursos económicos a través del
				pago dentro de la aplicación, ya que se constituye como un servicio que
				ofrece servicios de terceros. Needex mostrara dentro de los paneles
				diseñados el nombre, del usuario, el nombre de la persona referida como
				experto, la ubicación del sitio donde el experto se encuentre para poder
				requerir los servicios del mismo, dirección que el usuario tenga que
				brindar para que el experto pueda llegar al destino requerido, todo en
				tiempo real. Posteriormente para los expertos existirá el método de
				puntaje por el que los usuarios podrán calificar el trabaja brindando
				información adicional a los usuarios en general, este método de puntaje
				será únicamente para este fin. La información como el nombre de la
				persona por ambos lados se podrá observar en la aplicación, la dirección
				de ambas partes igualmente se podrá observar dentro de la aplicación,
				ver en tiempo real el transcurso que el experto tenga realizar hasta
				llegar a su destino podrá verse también dentro de la aplicación. Todos
				estos datos simplemente se usarán para el proceso que se lleve a cabo
				por los expertos, información que será solo para localizar, contactar
				con el experto y el usuario final.
			</p>

			<p>
				La información que se disponga en principio es solo para mostrarla
				dentro de la aplicación, de ninguna manera Needex brindara de otras
				formas la información personal de las y los usuarios que lleguen a
				interactuar con esta misma. Siempre podrás ver en nuestra página web las
				políticas de privacidad que describimos aquí ya que, posteriormente
				podrás ver si actualizamos estas mismas, agregando, mejorando o
				cambiando partes de las mismas a través de la siguiente url:{" "}
			</p>

			<a href="https://needex-bo.web.app">www.needex-bo.web.app</a>
		</div>
	);
};

export default PoliciesExperts;
